import { FreeProductMarkerProps } from "../../types/components/shared/FreeProductMarkerTypes"

import { FreeGiftIconLarge } from "../../modules/Icons"

export const containerStyles='py-4 px-[24px] rounded-[5px] bg-[#24c1ff1f] w-full flex gap-[20px]'
export const iconStyles ='!stroke-a-blue !w-[36px]'
export const textStyles ='inter w-fit text-[12px] md:text-[14px] font-light md:leading-24'

export const FreeProductMarker: React.FC<FreeProductMarkerProps> = (props) => {
  const { user } = props;
  
  return (
    <div cy-test-id="free-product-marker" className={containerStyles}>
      <div>
        <FreeGiftIconLarge cy-test-id="free-product-icon" className={iconStyles} />
      </div>
      <div>
        <p className={textStyles} cy-test-id="free-product-marker-text">
          { user?.token ? 
            <>This product is free to all ActionVFX users. <span className="font-bold">Download now!</span></> :
            <span> This product is free to all ActionVFX users. Sign up now to get access.</span>
          }
        </p>
      </div>
    </div>
  )
}